module.exports = __webpack_public_path__ + "img/pencil-outline-dark.099f6e99.svg";